import ChevronRightIcon from "assets/icon/ChevronRightIcon"
import EditIcon from "assets/icon/EditIcon"
import RevisionIcon from "assets/icon/RevisionIcon"
import ShowIcon from "assets/icon/ShowIcon"
import TrashIcon from "assets/icon/TrashIcon"
import moment from "moment"
import { Link, useNavigate } from "react-router-dom"
import { FormTypeAdd } from "utils/Constant"
import { GetStatus } from "utils/helpers"

export const FilterCard = ({ title, children, width }) => {
    const cardWidth = width || "w-full sm:w-72"

    return (
        <div className={`flex flex-col sm:gap-1 ${ cardWidth } text-sm`}>
            <div className="min-h-5">
                <span>{ title === '' ? ' ' : title }</span>
            </div>
            <div className="flex items-end">
                { children }
            </div>
            
        </div>
    )
}

export const FormCard = ({ title, children, width }) => {
    const cardWidth = width || "w-full sm:w-72"

    return (
        <div className="flex h-18 sm:h-10 text-sm">
            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                <div className="min-w-48">
                    <span>{ title }</span>
                </div>
                <div className="px-4 hidden sm:block">
                    <span>:</span>
                </div>
                <div className={` ${cardWidth}`}>
                    { children }
                </div>
            </div>
        </div>
    )
}

export const CreditCardDetailCard = ({ title, children, className }) => {
    return (
        <div className={`flex items-center ${className}`}>
            <div className="w-32 sm:w-48">
                <span className="">{title}</span>
            </div>
            <div className="px-2">
                <span>:</span>
            </div>
            <div className="flex items-center">
                <span>{children}</span>
            </div>
        </div>
    )
}

export const PagesTitle = ({ title }) => {
    return (
        <div className="flex flex-col gap-2">
            <div className="flex justify-between">
                <span className="font-semibold text-xl sm:text-xl">{ title }</span>
            </div>
            <hr />
        </div>
    )
}

export const PagesFormTitle = ({ title, formType, status, createDate, updateDate, updateBy }) => {
    return (
        <div className="flex flex-col gap-2">
            <div className="flex justify-between">
                <span className="font-semibold text-xl">{ title }</span>
                <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                    <span className="text-sm opacity-60">
                        Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                    </span>
                </div>
            </div>
            <hr />
        </div>
    )
}

export const SettingsCard = ({ onClick, title, icon }) => {
    return (
        <button className="px-4 py-4  w-full text-left flex justify-between hover" onClick={onClick}>
            <div className="flex items-center gap-4">
                <div className="w-6 flex justify-center">
                    {icon}
                </div>
                <span className="">{title}</span>
            </div>
            <ChevronRightIcon className="fill-black w-6" />
        </button>
    )
}

export const GridEditButton = ({ onClick, size = 'w-4', isActive = true }) => {
    return (
        <button className={`p-2 bg-black rounded-lg gap-2 ${isActive ? 'flex' : 'hidden'}`} onClick={onClick}>
            <EditIcon className={`fill-white ${size}`} />
        </button>
    )
}
export const GridViewButton = ({ onClick, size = 'w-4' }) => {
    return (
        <button className="p-2 bg-black rounded-lg flex gap-2" onClick={onClick}>
            <ShowIcon className={`fill-white ${size}`} />
        </button>
    )
}
export const GridDeleteButton = ({ onClick, size = 'w-4', status = '1' }) => {
    return (
        <button className="p-2 bg-black rounded-lg flex gap-2" onClick={onClick}>
            {status === '1' ? 
                <TrashIcon className={`fill-white ${size}`} /> :
                <RevisionIcon className={`fill-white ${size}`} /> 
            }
        </button>
    )
}
export const GridRevisionButton = ({ onClick }) => {
    return (
        <button className="p-2 bg-black rounded-lg flex gap-2" onClick={onClick}>
            <RevisionIcon className="w-4 fill-white" />
        </button>
    )
}

export const SidebarMenuButton = ({ children, onClick, title, href, visible, isOpen}) => {
    const navigate = useNavigate()

    return (
        <Link
            to={href}
            className={`w-full py-3 ${ isOpen ? 'px-4' : 'px-2' } 
                ${visible ? "" : "hidden"} 
                cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center text-sm
                ${
                    href === '/'
                        ? window.location.pathname === '/'
                        ? 'bg-slate-300'
                        : ''
                        : window.location.pathname === href || window.location.pathname.startsWith(`${href}/`)
                        ? 'bg-slate-300'
                        : ''
                    }
                ${ isOpen ? '' : 'justify-center' }
            `}
            onClick={onClick}
        >
            {children}
            <p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>{title}</p>
        </Link>
    )
}

export const MainBodyCard = ({ children }) => {
    return (
        <div className="p-3 h-[calc(100vh-3.5rem)] overflow-hidden">
            <div className="w-full h-[calc(100vh-5rem)] bg-white sm:border rounded-xl sm:p-6 flex flex-col overflow-auto">
                { children }
            </div>
        </div>
    )
}